import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/thum_img/kp708b/sub5_4/f2b765359d7c10695dcd8df292b4f145_water__c1_w500_h500.png'
import _imports_1 from '@/assets/thum_img/kp708b/sub5_4/7843c2c49ee35daacb0ab7893fec7d8e_water__c1_w500_h500.png'
import _imports_2 from '@/assets/thum_img/kp708b/sub5_4/439abe3b1fb6cfed8ad902d803d7082e_water__c1_w500_h500.jpg'


const _hoisted_1 = { class: "sub04_wrap" }

import { watch } from "vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";

export default /*@__PURE__*/_defineComponent({
  __name: 'Certification_Items',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_n_space = _resolveComponent("n-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createElementVNode("a", null, [
          _createElementVNode("figure", null, [
            _createVNode(_component_n_space, { justify: "center" }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  border: "0"
                }, null, -1)
              ])),
              _: 1
            })
          ])
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("h1", null, "초급과정 수료", -1))
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("a", null, [
          _createElementVNode("figure", null, [
            _createVNode(_component_n_space, { justify: "center" }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createElementVNode("img", {
                  src: _imports_1,
                  border: "0"
                }, null, -1)
              ])),
              _: 1
            })
          ])
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("h1", null, "고급과정 수료", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("p", null, "다중재능코칭전문가 2급 자격증 부여", -1))
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("a", null, [
          _createElementVNode("figure", null, [
            _createVNode(_component_n_space, { justify: "center" }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  border: "0"
                }, null, -1)
              ])),
              _: 1
            })
          ])
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("h1", null, "최고과정 수료", -1)),
        _cache[7] || (_cache[7] = _createElementVNode("p", null, "다중재능코칭전문가 1급 자격증", -1))
      ])
    ])
  ]))
}
}

})